module.exports = __webpack_public_path__ + "img/COMPLEXE SPORTIF DE SAINT-LAURENT.51fe2c53.jpg";